import Request from "./Request";
import { combineReducers } from "redux";
import Planning from "./Planning";
import CarryScore from "./CarryScore";
import Start from "./start";
import Loader from "./loader";
import PickListRubrics from "./PickListRubrics";
import HomeDashboard from "./HomeDashboard";
import PickListMaster from "./PickListMaster";
import Portfolio from "./Portfolio";
import auth from "./auth";
import checkApi from "./checkApi";
import Inbox from "./Inbox";
import Achievement from "./achievement";
import Admin from "./admin";
import CorporateGoal from "./corporateGoal";
import Calibration from "./calibration";
import ManagerDashboard from "./managerDashboard";
import notificationCenter from "./notificationCenter";

const reducers = combineReducers({
  auth,
  checkApi,
  Loader,
  Request,
  Planning,
  CarryScore,
  PickListRubrics,
  Start,
  HomeDashboard,
  PickListMaster,
  Portfolio,
  Inbox,
  Achievement,
  Admin,
  CorporateGoal,
  Calibration,
  ManagerDashboard,
  notificationCenter
});

export default reducers;
